"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  FontLanguage: () => import_core.FontLanguage,
  LinearGradient: () => LinearGradient,
  Spacer: () => import_core.Spacer,
  Stack: () => import_core.Stack,
  Text: () => import_core.Text,
  TextAncestorContext: () => import_core.TextAncestorContext,
  Theme: () => import_core.Theme,
  Unspaced: () => import_core.Unspaced,
  addTheme: () => import_core.addTheme,
  createComponent: () => import_core.createComponent,
  createFont: () => import_core.createFont,
  createShorthands: () => import_core.createShorthands,
  createTheme: () => import_core.createTheme,
  createTokens: () => import_core.createTokens,
  createVariable: () => import_core.createVariable,
  getAnimationDriver: () => import_core.getAnimationDriver,
  getConfig: () => import_core.getConfig,
  getMedia: () => import_core.getMedia,
  getStylesAtomic: () => import_core.getStylesAtomic,
  getThemes: () => import_core.getThemes,
  getTokens: () => import_core.getTokens,
  getVariable: () => import_core.getVariable,
  getVariableName: () => import_core.getVariableName,
  getVariableValue: () => import_core.getVariableValue,
  insertFont: () => import_core.insertFont,
  isChrome: () => import_core.isChrome,
  isClient: () => import_core.isClient,
  isServer: () => import_core.isServer,
  isTamaguiComponent: () => import_core.isTamaguiComponent,
  isTamaguiElement: () => import_core.isTamaguiElement,
  isTouchable: () => import_core.isTouchable,
  isVariable: () => import_core.isVariable,
  isWeb: () => import_core.isWeb,
  isWebTouchable: () => import_core.isWebTouchable,
  matchMedia: () => import_core.matchMedia,
  mediaObjectToString: () => import_core.mediaObjectToString,
  mediaQueryConfig: () => import_core.mediaQueryConfig,
  mediaState: () => import_core.mediaState,
  spacedChildren: () => import_core.spacedChildren,
  styled: () => import_core.styled,
  themeable: () => import_core.themeable,
  updateTheme: () => import_core.updateTheme,
  useDidFinishSSR: () => import_core.useDidFinishSSR,
  useEvent: () => import_core.useEvent,
  useGet: () => import_core.useGet,
  useIsTouchDevice: () => import_core.useIsTouchDevice,
  useIsomorphicLayoutEffect: () => import_core.useIsomorphicLayoutEffect,
  useMedia: () => import_core.useMedia,
  useSafeRef: () => import_core.useSafeRef,
  useStyle: () => import_core.useStyle,
  useTheme: () => import_core.useTheme,
  useThemeName: () => import_core.useThemeName,
  variableToString: () => import_core.variableToString,
  withStaticProperties: () => import_core.withStaticProperties
});
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, require("./setup"), module.exports);
__reExport(src_exports, require("@tamagui/adapt"), module.exports);
__reExport(src_exports, require("@tamagui/alert-dialog"), module.exports);
__reExport(src_exports, require("@tamagui/animate-presence"), module.exports);
__reExport(src_exports, require("@tamagui/avatar"), module.exports);
__reExport(src_exports, require("@tamagui/button"), module.exports);
__reExport(src_exports, require("@tamagui/card"), module.exports);
__reExport(src_exports, require("@tamagui/compose-refs"), module.exports);
__reExport(src_exports, require("@tamagui/create-context"), module.exports);
__reExport(src_exports, require("@tamagui/dialog"), module.exports);
__reExport(src_exports, require("@tamagui/font-size"), module.exports);
__reExport(src_exports, require("@tamagui/form"), module.exports);
__reExport(src_exports, require("@tamagui/group"), module.exports);
__reExport(src_exports, require("@tamagui/helpers-tamagui"), module.exports);
__reExport(src_exports, require("@tamagui/image"), module.exports);
__reExport(src_exports, require("@tamagui/label"), module.exports);
__reExport(src_exports, require("@tamagui/list-item"), module.exports);
__reExport(src_exports, require("@tamagui/popover"), module.exports);
__reExport(src_exports, require("@tamagui/popper"), module.exports);
__reExport(src_exports, require("@tamagui/portal"), module.exports);
__reExport(src_exports, require("@tamagui/progress"), module.exports);
__reExport(src_exports, require("@tamagui/radio-group"), module.exports);
__reExport(src_exports, require("@tamagui/scroll-view"), module.exports);
__reExport(src_exports, require("@tamagui/select"), module.exports);
__reExport(src_exports, require("@tamagui/separator"), module.exports);
__reExport(src_exports, require("@tamagui/shapes"), module.exports);
__reExport(src_exports, require("@tamagui/sheet"), module.exports);
__reExport(src_exports, require("@tamagui/slider"), module.exports);
__reExport(src_exports, require("@tamagui/stacks"), module.exports);
__reExport(src_exports, require("@tamagui/switch"), module.exports);
__reExport(src_exports, require("@tamagui/text"), module.exports);
__reExport(src_exports, require("@tamagui/tabs"), module.exports);
__reExport(src_exports, require("@tamagui/tooltip"), module.exports);
__reExport(src_exports, require("@tamagui/use-controllable-state"), module.exports);
__reExport(src_exports, require("@tamagui/use-debounce"), module.exports);
__reExport(src_exports, require("@tamagui/use-force-update"), module.exports);
__reExport(src_exports, require("@tamagui/use-window-dimensions"), module.exports);
__reExport(src_exports, require("@tamagui/visually-hidden"), module.exports);
__reExport(src_exports, require("@tamagui/checkbox"), module.exports);
__reExport(src_exports, require("./createTamagui"), module.exports);
__reExport(src_exports, require("./views/TamaguiProvider"), module.exports);
__reExport(src_exports, require("./viewTypes"), module.exports);
__reExport(src_exports, require("./views/Anchor"), module.exports);
__reExport(src_exports, require("./views/EnsureFlexed"), module.exports);
__reExport(src_exports, require("./views/Fieldset"), module.exports);
__reExport(src_exports, require("./views/Grid"), module.exports);
__reExport(src_exports, require("./views/Input"), module.exports);
__reExport(src_exports, require("./views/Layouts"), module.exports);
__reExport(src_exports, require("./views/Spinner"), module.exports);
__reExport(src_exports, require("./views/TextArea"), module.exports);
var import_core = require("@tamagui/core");
function LinearGradient(props) {
  if (process.env.NODE_ENV === "development") {
    console.warn(`LinearGradient has been moved to tamagui/linear-gradient as of 1.1`);
  }
  return null;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  FontLanguage,
  LinearGradient,
  Spacer,
  Stack,
  Text,
  TextAncestorContext,
  Theme,
  Unspaced,
  addTheme,
  createComponent,
  createFont,
  createShorthands,
  createTheme,
  createTokens,
  createVariable,
  getAnimationDriver,
  getConfig,
  getMedia,
  getStylesAtomic,
  getThemes,
  getTokens,
  getVariable,
  getVariableName,
  getVariableValue,
  insertFont,
  isChrome,
  isClient,
  isServer,
  isTamaguiComponent,
  isTamaguiElement,
  isTouchable,
  isVariable,
  isWeb,
  isWebTouchable,
  matchMedia,
  mediaObjectToString,
  mediaQueryConfig,
  mediaState,
  spacedChildren,
  styled,
  themeable,
  updateTheme,
  useDidFinishSSR,
  useEvent,
  useGet,
  useIsTouchDevice,
  useIsomorphicLayoutEffect,
  useMedia,
  useSafeRef,
  useStyle,
  useTheme,
  useThemeName,
  variableToString,
  withStaticProperties
});
//# sourceMappingURL=index.js.map
